import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IStateParamsService } from 'angular-ui-router';
import { Observable, Observer, of } from 'rxjs';
import { delayWhen, flatMap, take } from 'rxjs/operators';
import { IFocus } from 'Src/ng2/school/tiles/interfaces/dashboard.interfaces';
import { IGroupData } from 'Src/ng2/shared/models/list-models';
import {
  IStudentGroupingsPayload,
  LoadStudentGroupings,
  ResetStudentGroupings,
} from 'Src/ng2/store/actions/student-groupings-actions/student-groupings-actions';
import {
  getStudentGroupingsData,
  getStudentGroupingsLoadedStatus,
} from 'Src/ng2/store/selectors/student-groupings-selectors/student-groupings-selectors';

@Injectable()
export class StudentGroupingDataService {
  constructor(
    public store: Store<any>,
    @Inject('$stateParams')
    private $stateParams: IStateParamsService,
  ) {}

  getStudentGroupingPayload(focusData: IFocus, schoolId: string): Observable<IStudentGroupingsPayload> {
    const { filter, studentFilter } = this.$stateParams;
    const { studentLevelColumns, graphQlKeyPopulationFilter, defaultStudentLevelGrouping } = focusData;
    const filterOptions = studentFilter
      ? [filter, studentFilter, graphQlKeyPopulationFilter]
      : [filter, graphQlKeyPopulationFilter];
    const studentGroupingPayload = {
      schoolId,
      filterKeys: filterOptions,
      groupingKey: defaultStudentLevelGrouping.graphQlKey,
      columns: studentLevelColumns,
    };
    return of(studentGroupingPayload);
  }

  getStudentGroupingData$(studentGroupingPayload: IStudentGroupingsPayload): Observable<IGroupData[]> {
    this.store.dispatch(new ResetStudentGroupings());
    return this.store.select(getStudentGroupingsLoadedStatus).pipe(
      delayWhen((loaded: boolean) => this.loadStudentGroupingData$(loaded, studentGroupingPayload)),
      flatMap(() => this.store.select(getStudentGroupingsData)),
      take(1),
    );
  }

  loadStudentGroupingData$(loaded: boolean, studentGroupingPayload: IStudentGroupingsPayload): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      if (!loaded) {
        this.store.dispatch(new LoadStudentGroupings(studentGroupingPayload));
      } else {
        observer.next('student grouping loaded');
        observer.complete();
      }
    });
  }
}
